import clsx from 'clsx';
import React from 'react';
import ReactHtmlParser from 'react-html-parser';

import { PrimaryButton } from '@components/Button/variants';
import { TiModalColorScheme } from '@components/TIModal';
import useEventTracking from '@hooks/useEventTracking';
import { ClickTarget, click } from '@tracking';
import { getSafeUrl } from '@utils/safe_url';

export type ContentSmallProps = {
  buttonText?: string;
  modalTheme?: TiModalColorScheme;
  subtitle?: string;
  title?: string;
  customUrl?: string;
};

/**
 * A small, unobstructive modal that offers text-based headline, text, and CTA.
 * Growth calls this the Retention P0 LE Modal - Content Small.
 */
const ContentSmall = ({
  buttonText,
  modalTheme,
  subtitle,
  title,
  customUrl,
}: ContentSmallProps) => {
  const { trackEvent } = useEventTracking();
  const safeCustomUrl = getSafeUrl(customUrl, { allowRelative: true });

  const handleCTAClick = () => {
    trackEvent(
      click({
        clickTarget: ClickTarget.AnchorLink,
        clickText: buttonText,
        clickLink: safeCustomUrl,
      })
    );
  };

  const textColor = modalTheme === TiModalColorScheme.dark ? 'text-white' : 'text-primary-black';

  return (
    <div className="flex w-full flex-col flex-nowrap pt-6 sm:pt-0">
      <h3 className={clsx('my-0 font-suisse-screen text-byline-lg font-medium', textColor)}>
        {title}
      </h3>
      <p className={clsx('my-0 font-suisse-screen text-disclosure-md font-normal', textColor)}>
        {ReactHtmlParser(subtitle)}
      </p>
      <PrimaryButton
        as="link"
        className="mb-0 mt-16"
        href={safeCustomUrl}
        onClickCapture={handleCTAClick}
        size="small"
        fullWidth
      >
        {buttonText}
      </PrimaryButton>
    </div>
  );
};

export default ContentSmall;
